import { useState } from 'react'
import { Box, Button, Paper, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  cursorPointer: {
    cursor: 'pointer',
  },
}))

export default function FilterSegmentToggle({ children }: { children: React.ReactNode }) {
  const [showFilters, setShowFilters] = useState(false)
  const styles = useStyles()

  return (
    <Paper
      // allow Paper to accept the Box props
      component={Box}
      variant="outlined"
      // @ts-expect-error typing isn't picking up the Box props
      my={2}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px={2}
        py={1}
        onClick={() => setShowFilters(!showFilters)} // Add onClick handler to the container so a click anywhere will toggle the children
        className={styles.cursorPointer}
      >
        <Typography
          component="div"
          variant="subtitle2"
        >
          Filter segment
        </Typography>
        {/* Button is here for a11y/keyboard nav - click event will bubble up to container onClick handler */}
        <Button color="primary">{showFilters ? 'Hide Filters' : 'Show Filters'}</Button>
      </Box>
      {showFilters && (
        <Box
          px={2}
          py={1}
        >
          {children}
        </Box>
      )}
    </Paper>
  )
}
